// extracted by mini-css-extract-plugin
export default {"content":"VigboPrintTooltip__content--2u4VU"};